import Cookies from 'js-cookie'

const menu_list = [
  {	title: '123', children: [

  ]
  }

]

const app = {
  state: {
    sysDic: [],
    sidebar: {
      opened: !+Cookies.get('sidebarStatus'),
      withoutAnimation: false
    },
    device: 'desktop',
    language: Cookies.get('language') || 'zh',
    tableLoading: true,
    menu_list: [],
    menu_list2: []
  },
  mutations: {
    SET_TABLELOADING: (state, is_loading) => {
      state.tableLoading = is_loading
    },
    SET_SYSDIC: (state, sysDicData) => {
      state.sysDic = sysDicData
    },
    TOGGLE_SIDEBAR: state => {
      if (state.sidebar.opened) {
        Cookies.set('sidebarStatus', 1)
      } else {
        Cookies.set('sidebarStatus', 0)
      }
      state.sidebar.opened = !state.sidebar.opened
      state.sidebar.withoutAnimation = false
    },
    CLOSE_SIDEBAR: (state, withoutAnimation) => {
      Cookies.set('sidebarStatus', 1)
      state.sidebar.opened = false
      state.sidebar.withoutAnimation = withoutAnimation
    },
    TOGGLE_DEVICE: (state, device) => {
      state.device = device
    },
    SET_LANGUAGE: (state, language) => {
      state.language = language
      Cookies.set('language', language)
    },
    SET_MENU: (state, menu) => {
      state.menu_list = [{	title: '123', children: menu }]
	  },
    SET_MENU2: (state, menu_list2) => {
      state.menu_list2 = menu_list2
    }
  },
  actions: {
    setTableLoading({ commit }, is_loading) {
      commit('SET_TABLELOADING', is_loading)
    },
    setSysDic({ commit }, sysDic) {
      commit('SET_SYSDIC', sysDic)
    },
    toggleSideBar({ commit }) {
      commit('TOGGLE_SIDEBAR')
    },
    closeSideBar({ commit }, { withoutAnimation }) {
      commit('CLOSE_SIDEBAR', withoutAnimation)
    },
    toggleDevice({ commit }, device) {
      commit('TOGGLE_DEVICE', device)
    },
    setLanguage({ commit }, language) {
      commit('SET_LANGUAGE', language)
    },
    setMenu({ commit }, menu_list) {
      commit('SET_MENU', menu_list)
    },
    setMenu2({ commit }, menu_list) {
      commit('SET_MENU2', menu_list)
	  }
  },
  getters: {
    menu2: state => state.menu_list2,
    menu(state, getters, rootState) {
      function filterMenu(menuArray) {
        /*
			let menuRet = []
			for(let i=0;i<menuArray.length;i++){
				let m1 = menuArray[i]
				if(!hasPerm(m1)){continue}
				let copyOfM1 = Object.assign({},m1)
				menuRet.push(copyOfM1)
				if(m1.children){

					let menuRet2 = []
					copyOfM1.children = menuRet2

					for(let j=0;j<m1.children.length;j++){

						let m2 = m1.children[j]
						if(!hasPerm(m2)){continue}
						let copyOfM2 = Object.assign({},m2)
						menuRet2.push(copyOfM2)
						if(m2.children){

							let menuRet3 = []
							copyOfM2.children = menuRet3
							for(let k=0;k<m2.children.length;k++){
								let m3 = m2.children[k]
								if(!hasPerm(m3)){continue}
								let copyOfM3 = Object.assign({},m3)
								menuRet3.push(copyOfM3)

							}

						}

					}

				}

			}

			return menuRet   */

        return menuArray
      }
      function hasPerm(menu) {
        const user = rootState.user

        if (menu.level) {
          if (!menu.level.find(v => v == user.level)) { return false }
        }
        if (menu.type) {
          if (!menu.type.find(v => v == user.type)) { return false }
        }
        if (menu.biz_type) {
          if (!user.biz_type || user.biz_type.indexOf(menu.biz_type) == -1) { return false }
        }
        return true
      }
      return filterMenu(state.menu_list)
    }
  }
}

export default app



// WEBPACK FOOTER //
// ./src/store/modules/app.js